<template>
    <div class="detail-layout">
        <div class="detail-main">
            <div class="serm-pointer"><a href="#">规则体系</a>&gt;<a href="#">{{path.parent}}</a>&gt;<a href="#">{{path.children}}</a></div>
            <h1>{{detail.title}} <a :href="detail.pdfUrl" @click="downLoadLink()"><i></i>下载PDF</a> </h1>
            <div v-html="detail.content" class="detail-content"></div>
        </div>
        
    </div>
</template>
<script>
// import getDetailById from '@shared/data/getDetailById.json'
import {http, $tracker} from '@utils'
import {ruleApi} from '@utils/api'
import queryString from 'query-string';
import { mapState } from 'vuex'
export default {
    data(){
        return {
            path:{
                parent:'',
                children:'',
            },
            detail: {},
        }
    },
    computed:mapState([
        'menus',
    ]),
    created(){
        $tracker('288933',10000)
    },
    mounted(){
        const id = this.$route.query.id
        this.getPath(id)
        // this.$store.subscribe((mutation, state) => {
        //     console.log(2222, mutation)
        //     if(mutation && mutation.type == 'setMenus') {
        //         if(!this.path || !this.path.parent) {
        //             this.menus = mutation.payload;
        //             const id = this.$route.query.id
        //             this.getPath(id)
        //         }
        //     }
        // })
    },
    methods:{
        async getDetailById(id){
            const api = `${ruleApi.getDetailById}?id=${id}`
            const res = await http.get(`${api}`)
            if (1*res.code === 1) {
                this.detail = res.data
            }
            return res.data;
        },
        async getPath(id){
            const res = await this.getDetailById(id);
            const categoryId = res.categoryId
            this.$store.dispatch('getId',categoryId);
            // console.log('detail', categoryId)
            this.menus.forEach(item =>{
                item.children.forEach(el=>{
                    if(el.id == categoryId) {
                        this.path.children = el.title;
                        this.path.parent = item.title
                    }
                })
            })
        },
        downLoadLink() {
            $tracker('288933',20000, 200001)
        }
    }
}
</script>

<style lang="scss" scoped>
.detail-layout {
     padding-bottom: 15px;
    text-align: left;
    .detail-main {
        @include mHCMain;
        background-color: #fff;
        padding: 20px;
        .serm-pointer {
            color: #666;
            a {
                margin: 0 5px;
                text-decoration: none;
                color: #666;
            }
        }
        h1 {
            padding: 20px 0;
            border-bottom: 1px dashed #EEE;
            font-size: 18px;
            color: #333333;
            position: relative;
            text-align: center;
            line-height: 22px;
            font-weight: bold;
            a {
                position: absolute;
                font-size: 14px;
                font-weight: normal;
                right: 0;
                bottom: 10px;
                border: 1px solid #1C7AE5;
                border-radius: 3px;
                width: 100px;
                color: #1C7AE5;
                background-color: transparent;
                display: flex;
                justify-content: center;
                align-items: center;
                height: 30px;
                line-height: 30px;
                text-decoration: none;
                i {
                    display: block;
                    width: 16px;
                    height: 16px;
                    background: url('~@assets/images/download_icon.png') no-repeat;
                    background-size: 16px auto;
                    margin-right: 4px;
                }
            }
        }
        .detail-content {
            padding-top: 20px;
        }
    }
}

</style>

